var has = Function.call.bind(Object.prototype.hasOwnProperty);

export { has as default };
